class WishlistBackendResponseError extends Error {
  constructor(message) {
    super(message);
    this.name = 'WishlistBackendResponseError';
  }
}

// eslint-disable-next-line import/prefer-default-export
export { WishlistBackendResponseError };
